import apiClient from '../services/apiClient';

export function normalizeAuthUser(user) {
  if (!user || typeof user !== 'object') {
    return user;
  }

  const phoneNumber = user.phone_number || user.phone || null;
  const firstName = user.first_name || user.firstName || '';
  const lastName = user.last_name || user.lastName || '';
  const displayName = user.display_name || user.displayName || '';
  const countryCode = user.country_code || user.countryCode || 'NG';
  const location = user.location || '';
  const name =
    user.name || displayName || [firstName, lastName].filter(Boolean).join(' ').trim();

  return {
    ...user,
    display_name: displayName,
    country_code: countryCode,
    location,
    first_name: firstName,
    last_name: lastName,
    phone: phoneNumber,
    phone_number: phoneNumber,
    name: name || user.email || phoneNumber || '',
  };
}

export async function fetchCurrentUser() {
  try {
    const data = await apiClient.get('/auth/me', { parse: 'json', suppressError: true });
    return normalizeAuthUser(data);
  } catch (error) {
    if (error?.status === 401 || error?.status === 403) {
      return null;
    }
    throw error;
  }
}

export async function fetchShopForUser(user) {
  if (!user?.id) {
    return null;
  }

  const shops = await apiClient.get(`/users/${user.id}/shops`, {
    parse: 'json',
    suppressError: true,
  });
  return Array.isArray(shops) && shops.length > 0 ? shops[0] : null;
}

export async function loginWithCredentials(credentials) {
  const body = new URLSearchParams();
  if (credentials.email) body.append('email', credentials.email);
  if (credentials.phone_number) body.append('phone_number', credentials.phone_number);
  if (credentials.password) body.append('password', credentials.password);

  const response = await apiClient.request('/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
    parse: 'json',
  });

  return response;
}

export async function sendLogoutRequest(token) {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

  await apiClient
    .request('/auth/logout', {
      method: 'POST',
      headers,
      parse: 'text',
      suppressError: true,
    })
    .catch(() => null);
}
